import template from './cost_center.create.html';
import controller from './cost_center.create.controller';
import './cost_center.create.scss';

let CostCenterCreateComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template,
    controller
};

export default CostCenterCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/create/cost_center.create.component.js